import { render, staticRenderFns } from "./OtherComp.vue?vue&type=template&id=7ad189bf&scoped=true&"
import script from "./OtherComp.vue?vue&type=script&lang=js&"
export * from "./OtherComp.vue?vue&type=script&lang=js&"
import style0 from "./OtherComp.vue?vue&type=style&index=0&id=7ad189bf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad189bf",
  null
  
)

export default component.exports